import ToolTip from "../Components/Tooltip";

interface TelephoneInquiriesProps {
    inquiries: number
}

const TelephoneInquiries = ({inquiries}: TelephoneInquiriesProps) => {

    const telContent = `<p>
        Antall dokumenterte telefonsamtaler.<br>
        Målt på én av to måter:
        </p><ul>
            <li>Klikk på telefonnummer fra desktop for å vise hele nummeret</li>
            <li>Klikk på Ring til fra mobil web og app</li>
            
        </ul>`;

    return (
        <div className='col-md-6 mb-4'>
            <div className="card">
                <div className="card-header">
                <div className="d-flex align-items-center">
                    <h2 className="p2">Telefonhenvendelser</h2>
                    <ToolTip title='Telefonhenvendelser' content={telContent} id="telepopover" />
                </div>
                </div>
                <div className="card-body">
                <p className="fs-1">{new Intl.NumberFormat('nb-NO').format(inquiries)}</p>  
                </div>
            </div>
        </div>
    );
}

export default TelephoneInquiries;